module.exports = __webpack_public_path__ + "img/thank3.ee88c0c9.gif";